// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-close[data-v-57e405a6]{font-size:16px}.disabled-item[data-v-57e405a6]{opacity:.6;pointer-events:none!important}.case-settings[data-v-57e405a6]{position:fixed}", ""]);
// Exports
module.exports = exports;
